/** The two steps of signing in, in the order they happen. */
export enum LoginStepEnum {
  Key = "key",
  SignIn = "signIn",
}

export interface ILoginStepDef {
  step: LoginStepEnum;
  /** Key in the `app` namespace. */
  titleKey: string;
}

/** How far an auto-detect scan has gone — for the busy label on step one. */
export interface IDetectProgress {
  checked: number;
  total: number;
}
